import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { AuthLoginResponse, AuthRefreshTokenResponse, BiSession, RefreshTokenRequest, SurveyReport } from '../../core/auth/auth.type';
import { Observable } from 'rxjs';


const API_URL = `${environment.api.baseUrl ?? ""}${environment.api.services.authentication}`;

/**
 * Provides a base for authentication workflow.
 * The login/logout methods should be replaced with proper implementation.
 */
@Injectable()
export class AuthenticationService {
  
  constructor(private _http: HttpClient) {}

  authenticateUser(credentials: { email: string; password: string }): Observable<AuthLoginResponse> {
    return this._http.post<AuthLoginResponse>(`${API_URL}/tokens`, credentials);
  }

  /**
   * 
   * @param refreshTokenRequest 
   * @returns 
   */
  refreshToken(refreshTokenRequest: RefreshTokenRequest) : Observable<AuthRefreshTokenResponse> {
    return this._http.post<AuthRefreshTokenResponse>(`${API_URL}/refresh-token`, refreshTokenRequest);
  }
}
